export const BIG = 'big'
export const MEDIUM = 'medium'
export const NONE = 'none'

export const ALL_DOCUMENTATION_CHANGE_SEVERITY = [BIG, MEDIUM, NONE] as const

export type DocumentationChangeSeverity =
  (typeof ALL_DOCUMENTATION_CHANGE_SEVERITY)[number]
